export const IAP_FEATURES_CODES = {
    ABOUT_DEVICE: 'ABOUT_DEVICE',
    ADVANCED_DIAGNOSTIC: 'ADVANCED_DIAGNOSTIC',
    ADVANCED_DIAGNOSTIC_PHASE_2: 'ADVANCED_DIAGNOSTIC_PHASE_2',
    AI_ASSISTANT: 'AI_ASSISTANT',
    APPEARANCE: 'APPEARANCE',
    AUTO_START: 'AUTO_START',
    CONNECTIVITY: 'CONNECTIVITY',
    DASHBOARD: 'DASHBOARD',
    DEVICE_LOCK: 'DEVICE_LOCK',
    EXPERIENCE_SCORE: 'EXPERIENCE_SCORE',
    FLEX_BATTERY: 'FLEX_BATTERY',
    FLEX_PUFF: 'FLEX_PUFF',
    LED_INTENSITY: 'LED_INTENSITY',
    LOCATION: 'LOCATION',
    PAUSE_MODE: 'PAUSE_MODE',
    RANGE_MODE: 'RANGE_MODE',
    REMEMBER_HEATING_PROFILE: 'REMEMBER_HEATING_PROFILE',
    SETUP: 'SETUP',
    SIDEWALK: 'SIDEWALK',
    SMART_GESTURES: 'SMART_GESTURES',
    SOFTWARE_UPDATE: 'SOFTWARE_UPDATE',
    SWITCH_MASTER_BADGE: 'SWITCH_MASTER_BADGE',
    TIPS_AND_TUTORIALS: 'TIPS_AND_TUTORIALS',
    TUNABILITY: 'TUNABILITY',
    USAGE: 'USAGE',
    VIBRATION: 'VIBRATION',
    VIBRATION_INTENSITY: 'VIBRATION_INTENSITY',
};
